import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { LoginSuccess } from './types';

type AuthChallenge = 'SLACK_CODE';

export const authMutations = getMutations({
  initiateLogin: {
    action: async (payload: {
      email: string;
    }): Promise<{ challenge: AuthChallenge; sessionId: string }> => {
      return executeApiCall({
        path: '/login/initiate',

        payload,

        auth: false,
      });
    },

    messages: {
      error: (t) => ({
        title: t('login-error'),
        description: t('check-your-credentials-and-try-again') as string,
      }),

      suppressSuccess: true,
    },
  },

  completeLogin: {
    action: async (payload: {
      email: string;
      code: string;
      sessionId: string;
    }): Promise<LoginSuccess> => {
      return executeApiCall({
        path: '/login/complete',

        payload,

        auth: false,
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },

  assumeTeam: {
    action: async (payload: { teamId: string }): Promise<LoginSuccess> => {
      return executeApiCall({
        path: '/users/assume-team',

        payload,
      });
    },
  },
});
